// "NO SYSTEM ID ON SCREEN" (owner rule, 29 Sep 2026).
//
// Business keys come from Backend/utils/idGenerator.js as PREFIX + a
// zero-padded number (DR00001, PT00012, TN00001, MOC00008 …). A few fields a
// screen draws hold EITHER a person's label OR, when the server had nothing
// better, one of those keys — `heldBy` on a payment hold (the actor's e-mail,
// else their user id), the `doctorId` prop an invoice is handed. This tells the
// two apart so the screen can draw the label and drop the key.
//
// It is a guard for those mixed fields only. Where the field is KNOWN to be an
// id, a screen must simply not draw it.
export const isSystemId = (value) => /^[A-Z]{2,4}\d{3,}$/.test(String(value ?? '').trim());

export default isSystemId;
